module.exports = __webpack_public_path__ + "img/14.Panasonic2019.f03d1e2b.png";